import React from 'react';
import styled from 'styled-components';
import { SectionParent, B1, H2, H1, BlueButton } from '../../StyledComponents';
import Deploy from '../../../assets/avd/AppManage.svg';
import Lock from '../../../assets/avd/unique.svg';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import HardwareForm from '../../../templates/hardwareComponents/OdroidSectionFour';
import Remote from '../../../assets/avd/testing.svg';
import market from '../../../assets/v2/CustomHardware/market.svg';
import scale from '../../../assets/v2/CustomHardware/scale.svg';
import android from '../../../assets/v2/CustomHardware/secure-android.svg';
import remote from '../../../assets/v2/CustomHardware/remote-diag.svg';
import assist from '../../../assets/v2/CustomHardware/manu-assist.svg';
import { BottomBanner } from '../BottomBanner';
import { Modal, ModalContent } from '../AndroidX86/KioskSectionFive';

const Section = styled(SectionParent)`
  background: #ffffff;
  padding-top: 5rem !important;
  padding-bottom: 5rem !important;
  @media (max-width: 520px) {
    padding-top: 2rem !important;
    padding-bottom: 0rem !important;
  }
`;

const Grid = styled.div`
  margin-top: 3rem;
  @media (min-width: 520px) {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
  }
  @media (max-width: 520px) {
    margin-top: 3rem;
  }
`;

const GridItem = styled.div`
  justify-self: start;
  max-width: 100%;
  grid-column: span 2;
  align-self: center;
  padding-bottom: 2rem;
  @media (max-width: 768px) {
    margin-left: 5rem;
  }
  @media (max-width: 520px) {
    grid-column: span 1;
    margin-bottom: 3rem;
    padding-bottom: 0rem;
    display: grid;
    margin-left: 0rem;
    justify-items: center;
  }
`;
const GridItemRight = styled.div`
  justify-self: end;
  max-width: 100%;
  grid-column: span 2;
  align-self: center;
  padding-bottom: 2rem;
  @media (max-width: 768px) {
    margin-right: 5rem;
  }
  @media (max-width: 520px) {
    grid-column: span 1;
    margin-bottom: 3rem;
    padding-bottom: 0rem;
    display: grid;
    margin-right: 0rem;
    justify-items: center;
  }
`;
const FounderName = styled(H2)`
  padding-top: 2rem;
  @media (max-width: 520px) {
    text-align: left;
  }
  font-size: 24px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.92;
  letter-spacing: normal;
  color: #4d3df4;
`;

const SectionLeftImage = styled(LazyLoadImage)`
  max-width: 250px;
  width: 65%;
  justify-self: end;
  @media (max-width: 768px) {
    width: 100%;
  }
  @media (max-width: 520px) {
    margin-left: 0rem;
    width: 50%;
    justify-self: center;
  }
`;
const SectionRightImage = styled(LazyLoadImage)`
  max-width: 250px;
  width: 44%;
  justify-self: center;
  @media (max-width: 768px) {
    width: 100%;
  }
  @media (max-width: 520px) {
    display: none;
  }
`;
const SectionRightImageMobile = styled(LazyLoadImage)`
  max-width: 50%;
  justify-self: center;
  @media (min-width: 521px) {
    display: none;
  }
`;
const SectionSubHeading = styled(H2)`
  padding-top: 1rem;

  font-weight: 500;
  font-size: 24px;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.26;
  width: 70%;
  letter-spacing: normal;
  text-align: left;
  color: #26315c;
  @media (max-width: 520px) {
    width: 100%;
  }
`;
const SectionSubHeadingRight = styled(H2)`
  padding-top: 1rem;

  font-weight: 500;
  font-style: normal;
  font-size: 24px;
  font-stretch: normal;
  line-height: 1.26;
  letter-spacing: normal;
  text-align: left;
  color: #26315c;
  @media (max-width: 520px) {
    text-align: center;
    padding-left: 0;
  }
`;

const SectionContent = styled(B1)`
  font-family: 'Nunito Sans', sans-serif;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.61;
  letter-spacing: normal;
  width: 80%;
  color: #6a718c;

  padding-top: 0.5rem;
  text-align: justify;
  img {
    margin-top: 1rem;
  }
  @media (max-width: 520px) {
    text-align: center;
    width: 90%;
  }
`;

const SectionContentSecond = styled(B1)`
  font-family: 'Nunito Sans', sans-serif;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.61;
  letter-spacing: normal;
  width: 100%;
  color: #6a718c;
  padding-top: 0.5rem;
  text-align: left;
  img {
    margin-top: 1rem;
  }
  @media (max-width: 520px) {
    padding-left: 0;
    text-align: center;
    width: 90%;
  }
`;

const ImgWrapper = styled.div`
  display: grid;
  align-items: center;
  padding-right: 3rem;
  @media (max-width: 520px) {
    padding-right: 0;
  }
`;
const PageTitle = styled(H1)`
  color: #151a2e;

  font-size: 36px;
  line-height: 1.28;
  justify-self: center;
  text-align: center;
  margin-bottom: 2rem;
  padding-right: 15%;
  /* font-weight: 600; */
  @media (max-width: 768px) {
    margin-bottom: 2rem;
  }
  @media (max-width: 550px) {
    margin-bottom: 2rem;
  }
  @media (max-width: 520px) {
    font-size: 24px;
    padding-right: 0;
  }
`;

const SectionOuter = styled.div`
  width: 80%;
  margin-left: 15%;
  @media (max-width: 520px) {
    margin-left: 10%;
  }
`;
const BlueButtonWrapper = styled.div`
  /* margin-left: -10px; */
  display: grid;
  justify-content: center;
  margin-top: 5rem;
  @media (max-width: 768px) {
    text-align: center;
  }
  @media (max-width: 520px) {
    justify-self: center;
    margin-top: 2rem;
  }
`;

const BlueButtonNew = styled(BlueButton)`
  background-color: #725cbd;
  color: #ffffff;
`;
export default class CustomHardwareSectionFour extends React.Component<
  any,
  any
> {
  OpenModal = (event: any) => {
    event.stopPropagation();
    const modal = document.getElementById('myModal');
    if (modal !== null) {
      modal.style.display = 'block';
    }
  };
  CloseModal = (event: any) => {
    const modal = document.getElementById('myModal');
    if (modal !== null) {
      modal.style.display = 'none';
    }
  };
  render() {
    return (
      <div>
        <Modal id="myModal" style={{ zIndex: '2' }} className="modal">
          <ModalContent className="modal-content">
            <span
              className="close"
              onClick={this.CloseModal}
              style={{
                display: 'grid',
                justifyContent: 'end',
                cursor: 'pointer',
              }}
            >
              &times;
            </span>
            <HardwareForm formId="custom_hardware_form" />
          </ModalContent>
        </Modal>
        <SectionOuter>
          <Section>
            <PageTitle>Benefits</PageTitle>
            <Grid>
              <ImgWrapper>
                <SectionLeftImage src={market} alt="auto deploy" />
              </ImgWrapper>
              <GridItem>
                <SectionSubHeading>Time to Market</SectionSubHeading>
                <SectionContent>
                  Reduce time involved in developing customized Hardware using
                  approved SOMs from MediaTek’s hardware partners and accelerate
                  your time to market by using Esper’s cloud solution for
                  managing your application and device deployments. Ship as fast
                  as 3 months from Design to Mass Production.
                </SectionContent>
              </GridItem>
            </Grid>
            <Grid>
              <GridItemRight>
                <SectionRightImageMobile src={scale} alt="lock" />
                <SectionSubHeadingRight>
                  Scale Device Deployment
                </SectionSubHeadingRight>
                <SectionContentSecond>
                  Ship your hardware as fast as you can build the application.
                  Using Espers Android platform, remotely set up and deploy your
                  devices, which helps you reduce operations cost drastically.
                </SectionContentSecond>
              </GridItemRight>
              <ImgWrapper>
                <SectionRightImage src={scale} alt="lock device" />
              </ImgWrapper>
            </Grid>
            <Grid>
              <ImgWrapper>
                <SectionLeftImage src={android} alt="remote" />
              </ImgWrapper>
              <GridItem>
                <SectionSubHeading>
                  Enterprise-focused Secure Android ROM
                </SectionSubHeading>
                <SectionContent>
                  Esper customizes the Android OS to suit the application needs,
                  including in-ROM apps and specific peripheral support. No more
                  spyware from unknown hardware vendors leaking critical
                  enterprise data.
                </SectionContent>
              </GridItem>
            </Grid>
            <Grid>
              <GridItemRight>
                <SectionRightImageMobile src={remote} alt="lock" />
                <SectionSubHeadingRight>
                  Remote Diagnosis
                </SectionSubHeadingRight>
                <SectionContentSecond>
                  Manage your device fleet remotely without any hassle using
                  Esper Dev tools. Debug, update and manage all your devices
                  around-the-clock with Esper.
                </SectionContentSecond>
              </GridItemRight>
              <ImgWrapper>
                <SectionRightImage src={remote} alt="lock device" />
              </ImgWrapper>
            </Grid>
            <Grid>
              <ImgWrapper>
                <SectionLeftImage src={assist} alt="remote" />
              </ImgWrapper>
              <GridItem>
                <SectionSubHeading>
                  Manufacturing Assistance with MediaTek
                </SectionSubHeading>
                <SectionContent>
                  Get your applications validated on reference MTK Board using
                  Esper tools. Custom manufacture your hardware from MTK
                  approved contract manufacturers.
                </SectionContent>
              </GridItem>
            </Grid>

            <BlueButtonWrapper>
              <BlueButtonNew
                id="custom_hardware__tell_us_your_requirements"
                onClick={this.OpenModal}
              >
                Tell Us Your Requirements
              </BlueButtonNew>
            </BlueButtonWrapper>
          </Section>
        </SectionOuter>
      </div>
    );
  }
}
